var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"shuffle-card"},[_c('ul',{staticClass:"overview"},_vm._l((_vm.shuffle.token_info),function(nft){return _c('Card',{key:nft.token_id,attrs:{"data":{token_id: nft.token_id, extension: nft.extension, content_type: nft.content_type, to: `/shuffle/${_vm.shuffle.id}`, ..._vm.shuffle}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }